module.exports = __webpack_public_path__ + "img/game_person_half.49113389.png";